<template>
  <div>
    <PicList
      :category="category"
      @showpic="$emit('showPic', $event)"
    ></PicList>
  </div>
</template>

<script>
import PicList from './PicList';

export default {
  components: {
    PicList
  },
  data() {
    return {
      category: "表情包"
    }
  }
}
</script>
